module.exports = __webpack_public_path__ + "fonts/Lato-Regular.e72d1ee.woff";